export const ADD_TOKEN = 'ADD_TOKEN';
export const DELETE_TOKEN = 'DELETE_TOKEN';

const initialState = {
  tokenList: [],

};

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_TOKEN:
      return {
        ...state,
        tokenList: [...state.tokenList, action.payload],
      };
    case DELETE_TOKEN:
      return {
        ...state,
        tokenList: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/token.js